/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host {
  width: 100%;
  height: 100%;
  position: relative;
}
:host > div {
  width: 100%;
  height: 100%;
  position: relative;
}
:host #ws {
  color: transparent;
  font-size: 0;
  height: 0;
  overflow: hidden;
}
:host .discovery-tile-spinner {
  position: absolute;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
:host .discovery-tile-error {
  background-color: var(--warp-view-error-bg-color, #dc3545);
  color: var(--warp-view-error-color, #ffffff);
  text-align: center;
  position: absolute;
  width: calc(100% - 40px);
  padding: 20px;
  height: calc(100% - 40px);
  z-index: 9;
  display: grid;
  align-items: center;
}
:host .discovery-tile-status {
  background-color: var(--warp-view-status-bg-color, #d1ecf1);
  color: var(--warp-view-status-color, #0c5460);
  text-align: center;
  position: relative;
  padding: 5px 10px;
  width: calc(100% - 40px);
  margin-top: 12px;
}
:host .hidden-by-ws {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}